import { styled, keyframes } from '@mui/material/styles';
import { COLOR } from '@src/styles/color';

const slideIn = keyframes`
  from {
    opacity: 0;
    transform: translateX(16px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
`;

export const StyledSidebar = styled('div')`
  width: 368px;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 16px;
  box-sizing: border-box;
  background: ${COLOR.charcoalV2[64]};
  border: 0.5px solid ${COLOR.indigo[16]};
  border-radius: 12px;
  overflow-y: auto;
  animation: ${slideIn} 0.2s ease-out;

  .error-msg {
    display: block;
    font-size: 12px;
    font-weight: 400;
    margin-top: 4px;
    color: ${COLOR.redPrimary};
  }
`;

export const StyledHeader = styled('div')`
  display: flex;
  align-items: center;
  gap: 8px;

  .title {
    flex: 1;
    font-size: 16px;
    font-weight: 600;
    line-height: 24px;
    color: ${COLOR.black.default};
  }
`;

export const StyledLabel = styled('div')`
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  color: ${COLOR.darkGray};
  margin-bottom: 4px;

  > span:first-of-type {
    flex: 1;
    min-width: 0;
  }
`;

export const StyledInputGroup = styled('div')`
  display: flex;
  gap: 4px;
  align-items: flex-start;

  .input-container {
    flex: 1;
    position: relative;
    display: flex;
    flex-direction: column;
    min-height: 80px;
    padding: 12px;
    box-sizing: border-box;
    border: 0.5px solid ${COLOR.indigo[16]};
    border-radius: 12px;
    background: #fff;

    &:focus-within {
      border-color: ${COLOR.blueV2};
    }

    textarea {
      flex: 1;
      width: 100%;
      padding: 0;
      border: none;
      font-size: 14px;
      font-weight: 500;
      line-height: 20px;
      color: ${COLOR.darkBlue};
      outline: none;
      background: transparent;
      resize: none;
      font-family: inherit;
    }

    .char-count {
      align-self: flex-end;
      font-size: 12px;
      font-weight: 400;
      line-height: 16px;
      color: rgba(28, 28, 30, 0.48);
      pointer-events: none;
      margin-top: 4px;
    }
  }

  &.has-error .input-container {
    border-color: ${COLOR.redPrimary};

    &:focus-within {
      border-color: ${COLOR.redPrimary};
    }
  }
`;

export const StyledActions = styled('div')`
  display: flex;
  align-items: center;
  justify-content: space-between;

  .nav-group {
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .action-group {
    display: flex;
    align-items: center;
    gap: 8px;
  }
`;

export const StyledMenuContent = styled('div')`
  width: 216px;
  padding: 8px;
`;
